type SliderValueInput = number | readonly number[] | undefined;

function getFiniteSliderNumber(value: number | undefined, fallback: number) {
  return typeof value === 'number' && Number.isFinite(value) ? value : fallback;
}

function getSliderBounds(min: number | undefined, max: number | undefined) {
  const safeMin = getFiniteSliderNumber(min, 0);
  const safeMax = getFiniteSliderNumber(max, safeMin + 100);

  return safeMax > safeMin
    ? { min: safeMin, max: safeMax }
    : { min: safeMin, max: safeMin + 100 };
}

function normalizeSliderValue(value: number, min: number, max: number) {
  const safeValue = Number.isFinite(value) ? value : min;
  return Math.min(max, Math.max(min, safeValue));
}

function toSliderArray(value: SliderValueInput) {
  if (typeof value === 'number') {
    return [value];
  }

  return value;
}

function normalizeSliderValues(
  values: SliderValueInput,
  min: number,
  max: number,
) {
  return toSliderArray(values)?.map((value) =>
    normalizeSliderValue(value, min, max),
  );
}

function getSliderValueCount(value: SliderValueInput) {
  return toSliderArray(value)?.length;
}

function getThumbCount(count: number | undefined) {
  return typeof count === 'number' && Number.isFinite(count) && count > 0
    ? Math.floor(count)
    : 1;
}

export {
  getSliderBounds,
  getSliderValueCount,
  getThumbCount,
  normalizeSliderValues,
};
